
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"37","fill":"none","viewBox":"0 0 60 37"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M57.3 37H2.5C1.1 37 0 35.9 0 34.6V2.4C0 1.1 1.1 0 2.5 0h54.7c1.4 0 2.5 1 2.6 2.4v32.2c0 1.3-1.1 2.4-2.5 2.4zM2.5 1C1.7 1 1 1.7 1 2.4v32.2c0 .8.6 1.4 1.5 1.4h54.8c.8 0 1.5-.7 1.5-1.4V2.4c-.1-.8-.7-1.4-1.6-1.4H2.5z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M18.21 13.98l-6.78-3.92a.784.784 0 00-.7 0l-6.78 3.92c-.19.11-.35.38-.35.6v7.84c0 .22.16.49.35.6l6.78 3.92c.19.11.51.11.7 0l6.78-3.92c.19-.11.35-.38.35-.6v-7.84c0-.22-.16-.49-.35-.6zm-8.24 8.67s-.21.31-.54.31c-.33 0-.52-.29-.54-.32l-3.04-4.5c-.18-.27-.61-1.05-.12-2.06.43-.88 1.24-1.26 1.98-1.26.28 0 .58.06.86.18l-.61 1.12a.746.746 0 00-.26-.04c-.73 0-1.09.79-.77 1.31.3.49.77 1.19.77 1.19l1.74 2.44.66-.93.79 1.16-.91 1.4h-.01zm3.41-.01s-.22.31-.54.31c-.33 0-.52-.29-.53-.3l-1.18-1.81-.79-1.14c-.48-.72-1.06-1.57-1.06-1.57-.18-.27-.61-1.05-.12-2.06.43-.88 1.24-1.26 1.98-1.26s1.58.41 1.97 1.26c.48 1.05.06 1.81-.13 2.09l-1.04 1.56.91 1.39 1.77-2.6v.02h1.53l-2.77 4.11zm9.17-6.05h2.18v6.21h1.72v-6.21h2.18v-1.45h-6.08v1.45z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M11.14 16.08c-.73 0-1.09.79-.77 1.31.3.49.77 1.19.77 1.19s.47-.7.77-1.19a.875.875 0 00-.77-1.31zm30.35-.94h-1.7v7.66h1.7v-7.66zm8.64 0v1.45h2.18v6.21h1.72v-6.21h2.17v-1.45h-6.07zm-3.93-.24c-1.91 0-2.97 1.22-2.97 2.99v4.91h1.7v-4.95c0-.77.45-1.36 1.29-1.36.84 0 1.28.7 1.28 1.36v4.95h1.7v-4.91c0-1.77-1.09-2.99-3-2.99zm-10.37 4.27l-.06.43-.08-.43-1.39-4.03h-.55l-1.39 4.03-.08.43-.06-.43-1.03-4.03h-1.68l2.17 7.66h.69l1.6-4.28.05-.34.06.34 1.6 4.28h.69l2.17-7.66h-1.67l-1.04 4.03z"}})])
          )
        }
      }
    